import { Link } from 'react-router-dom';
import * as z from 'zod';

import { Button } from '@/components/Elements';
import { Form, InputField } from '@/components/Form';
import { useForgotPassword } from '../api/forgotPassword.api';

const schema = z.object({
  email: z.string().min(1, 'Required'),
});

export const ForgetPasswordForm = ({ onSuccess }) => {
  const forgotPassword = useForgotPassword();

  return (
    <div>
      <Form
        onSubmit={async (values) => {
          await forgotPassword.mutateAsync(values.email);
          onSuccess();
        }}
        schema={schema}
      >
        {({ register, formState, watch }) => {
          const emailValue = watch('email');

          return (
            <>
              <InputField
                type="email"
                label="Email"
                labelTextClassName="flex flex-col gap-2"
                className="rounded-xl"
                placeholder="email@company.com"
                error={formState.errors['email']}
                registration={register('email')}
              />
              <div>
                <Button
                  type="submit"
                  className={`w-full rounded-lg ${
                    !emailValue
                      ? 'bg-pv-neutral-grey-100 text-pv-neutral-grey-300 hover:bg-pv-neutral-grey-100 hover:text-pv-neutral-grey-300'
                      : 'bg-brand-ai-100'
                  } btn-style  text-sm`}
                >
                  Request Reset Link
                </Button>
              </div>
            </>
          );
        }}
      </Form>
      <div className="mt-6 flex items-center justify-center">
        <div className="text-sm">
          <Link
            to="../login"
            className=" text-brand-ai-100 hover:text-blue-500"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};
